module.exports = __webpack_public_path__ + "media/images/flags/jo-24bd76f285a855b886bea1dbc8aff546.svg";